// extracted by mini-css-extract-plugin
module.exports = {"view":"UserGroup_view__1d8x9"};